export const sklonenieWord = (number: number, variantText: string[]) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return variantText[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
};

export const capitalize = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1);
